import AbstractItemResource from "../abstract/abstract-item-resource"
import defines from "dpsdk/defines"
const {Resource, AlertType} = defines

class Ticket extends AbstractItemResource {
    constructor(data, parent) {
        super(Resource.TICKETS, data, parent)
        this.setLabels({
            id: 'ID'
        })
    }


    static statusesForDropDown(t) {
        return [
            {
                label: t('tickets.status.0'),
                value: 0
            },
            {
                label: t('tickets.status.1'),
                value: 1
            },
            {
                label: t('tickets.status.2'),
                value: 2
            },
            {
                label: t('tickets.status.3'),
                value: 3
            }
        ]
    }

    static priorityForDropDown(t) {
        return [
            {
                label: t('tickets.priority.0'),
                value: 0
            },
            {
                label: t('tickets.priority.1'),
                value: 1
            },
            {
                label: t('tickets.priority.2'),
                value: 2
            }
        ]
    }

    color() {
        switch (this.status) {
            case 0:
                return 'info'
            case 1:
                return 'primary'
            case 2:
                return 'success'
            case 3:
                return 'secondary'
        }
    }

    priorityColor() {
        switch (this.priority) {
            case 0:
                return 'secondary'
            case 1:
                return 'primary'
            case 2:
                return 'danger'
        }
    }

    getDevice(devices) {
        const el = devices.forDropDown().find(el => el.value === this.device_id)
        if (el) {
            return el.label
        }

        return '-'
    }

    getResponsible(users) {
        const result = []
        for (const id of this.responsible_ids) {
            const el = users.forDropDown().find(el => el.value === id)
            if (el) {
                result.push(el.label)
            }
        }

        if (result.length === 0) {
            return '-'
        }

        return result.join(', ')
    }

    getCreatedBy(users) {

        const el = users.forDropDown().find(el => el.value === this.created_by)
        if (el) {
            return el.label
        }

        return '-'
    }

    getStatusStr(t) {
        let result = ''
        const el = Ticket.statusesForDropDown(t).find(el => el.value === this.status)
        if (el) {
            result += el.label
        }

        return result
    }

    getPriorityStr(t) {
        let result = ''
        const el = Ticket.priorityForDropDown(t).find(el => el.value === this.priority)
        if (el) {
            result += el.label
        }

        return result
    }
}

export default Ticket
